import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6'
import * as actions from './actions';

import { selectPolicies, initiateClaimdcp, initiateMthunziClaim, getCustomerClaimsDcp } from '../../../lib/requests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';


export function* selectPolicyRequestWatcher() {
  for (; ;) {
    const request = yield take(types.GET_EVENT_QUOTE_REQUEST);
    try {
      const response = yield call(selectPolicies, request.payload);
      yield put(actions.getEventQuoteSuccess(response.data));

    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getEventQuoteFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

// Mthunzi (Old Mutual Malawi) submits through the underwriter engine directly rather than the generic
// /api/claims/complex/initiate_claim endpoint - handleInitiateClaim() in
// partner-apps/OldMutualMalawi/ClaimInitiation/index.js tags the payload with __engineFlow ('mthunzi')
// to select this path, and strips it before sending. This is the saga actually wired into the root store
// for state.claimInitiationData (see src/reducers.es6.js / src/rootSaga.es6.js) - the parallel files under
// partner-apps/OldMutualMalawi/ClaimInitiation/Redux/ are never registered and never run.
function claimRequestCall(payload) {
  const { __engineFlow, ...body } = payload;
  if (__engineFlow === 'mthunzi') return call(initiateMthunziClaim, body);
  return call(initiateClaimdcp, payload);
}

// Always returns a plain string - ClaimDetails.js renders this directly as JSX text, and React throws
// if handed an object instead. The underwriter engine returns { success: false, error: { message } };
// /api/claims/complex/initiate_claim's own 400s come back as a plain NestJS { message, error, statusCode }
// body instead - data.message covers that shape, and the JSON.stringify fallback guards against any other
// unexpected response shape reaching the render tree as a raw object.
function claimErrorMessage(e) {
  const data = e.response && e.response.data;
  if (typeof data === 'string') return data;
  if (data && data.error && data.error.message) return data.error.message;
  if (data && typeof data.message === 'string') return data.message;
  if (data) return JSON.stringify(data);
  return 'An unexpected error occurred';
}

export function* initiateClaimDcpRequestWatcher() {
  for (; ;) {
    const request = yield take(types.INITIATE_CLAIM_REQUEST);
    try {
      const response = yield claimRequestCall(request.payload);
      yield put(actions.initiateClaimSuccess(response.data));

    } catch (e) {
      yield put(actions.initiateClaimFailure(claimErrorMessage(e)));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getCustomerClaimsDcpRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_CUSTOMER_CLAIMS_DCP_REQUEST);
    try {
      const response = yield call(getCustomerClaimsDcp, request.payload);
      yield put(actions.getCustomerClaimsDcpSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getCustomerClaimsDcpFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
